export default __webpack_public_path__ + "static/agenda-0a54cc1beac8670aac4a2d82e1e4e4df.png";